import { useRef } from 'react';

const empty = Symbol('empty');

export function useConstant<GetConstantResult>(getConstant: () => GetConstantResult): GetConstantResult;
export function useConstant<Constant>(constant: Constant): Constant;
export function useConstant(constant: unknown): unknown {
  const ref = useRef<symbol | unknown>(empty);

  if (ref.current === empty) {
    ref.current = typeof constant === 'function' ? constant() : constant;
  }

  return ref.current;
}
